export const iconProps = {
  strokeWidth: 1.8,
  size: 24,
  size$dense: 20,
}
